"use strict";

var integrationsListCtrl = [
  "$uibModal",
  "Integration",
  "ReportConfig",
  function ($uibModal, Integration, ReportConfig) {
    var _this = this;

    this.openConfig = function () {
      var options = {
        animation: true,
        controller: [
          "form",
          "integrations",
          function (form, integrations) {
            function walkNodes(fields) {
              return fields.reduce((lst, field) => {
                if (field.nodes && field.nodes.length > 0)
                  lst = lst.concat(walkNodes(field.nodes));
                if (field.integration && field.integration.id){
                  const integration=_this.integrations.find(int=>int.id==field.integration.id) || {name:"¿?",type:"¿?"};
                  lst.push({
                    integration:{id:field.integration.id,name:integration.name,type:integration.type},                    
                    fieldId: field.id,
                    label: field.name || field.label,
                    type: field.type,
                  });
                }
                return lst;
              }, []);
            }
            var _this = this;
            this.form = form;
            this.integrations = integrations;
            console.log("integrationsListCtrl");
            this.lstIntegrationsUsing = _this.form.pages.reduce((lst,page)=>lst.concat(walkNodes(page.fields)),[]);
            this.lstValidateIntegrationsUsing = (_this.form.validate_pages || []).reduce((lst,page)=>lst.concat(walkNodes(page.fields)),[]);
            // console.log('this.lstIntegrationsUsing', this.lstIntegrationsUsing)
            // console.log('this.lstValidateIntegrationsUsing', this.lstValidateIntegrationsUsing);

            this.close = function () {
              _this.$close(_this.element);
            };
          },
        ],
        templateUrl:
          "dashboard-builder/integrationsList/integrationsListDirectiveModal.html",
        controllerAs: "ctrl",
        size: "lg",
        windowClass: "dialog",
        bindToController: true,
        resolve: {
          form: function () {
            return _this.form;
          },
          integrations: function () {
            return Integration.find().$promise.then(function (integrations) {
              return integrations;
            });
          },
        },
      };

      $uibModal.open(options).result.then(
        function (element) {
          _this.element.integration = element.integration;
          _this.element.reportConfig = element.reportConfig;
          if (Array.isArray(element.metadata)) {
            element.metadata = element.metadata.reduce((lst, item) => {
              if (item.value != undefined && item.value != "") lst.push(item);
              return lst;
            }, []);
            if (element.metadata.length == 0) _this.element.metadata = null;
            else _this.element.metadata = [].concat(element.metadata);
          } else delete _this.element.metadata;
          return;
        },
        function () {
          return;
        }
      );
    };
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      element: "=",
      form: "=",
      hideIntegrationsTabs: "=",
    },
    replace: true,
    controller: integrationsListCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl:
      "dashboard-builder/integrationsList/integrationsListDirective.html",
  };
};
